export const PERMISSION_PARTNER_TRANSPORT = {
  ADD: 'MD_PARTNERTRANSPORT_ADD',
  EDIT: 'MD_PARTNERTRANSPORT_EDIT',
  VIEW: 'MD_PARTNERTRANSPORT_VIEW',
  DELETE: 'MD_PARTNERTRANSPORT_DEL',
};

export const CARRIER_CODE_OPTIONS = [
  { label: 'Tự vận chuyển / chưa kết nối', value: 'MANUAL' },
  { label: 'Giao Hàng Nhanh (GHN)', value: 'GHN' },
  { label: 'Giao Hàng Tiết Kiệm (GHTK)', value: 'GHTK' },
  { label: 'Viettel Post', value: 'VIETTEL_POST' },
  { label: 'J&T Express', value: 'JNT' },
  { label: 'Đơn vị khác', value: 'OTHER' },
];

export const INTEGRATION_MODE_OPTIONS = [
  { label: 'Thủ công', value: 'MANUAL' },
  { label: 'Kết nối API', value: 'API' },
];

export const INTEGRATION_ENVIRONMENT_OPTIONS = [
  { label: 'Sandbox/Test', value: 'SANDBOX' },
  { label: 'Production', value: 'PRODUCTION' },
];

export const YES_NO_OPTIONS = [
  { label: 'Có', value: 1 },
  { label: 'Không', value: 0 },
];

export const FEE_PAYER_OPTIONS = [
  { label: 'Cửa hàng trả', value: 'SHOP' },
  { label: 'Khách nhận trả', value: 'CUSTOMER' },
];

export const COD_COLLECTION_TYPE_OPTIONS = [
  { label: 'Đơn vị vận chuyển thu hộ', value: 'CARRIER_COLLECT' },
  { label: 'Cửa hàng tự thu', value: 'SHOP_COLLECT' },
  { label: 'Không thu COD', value: 'NO_COD' },
];
